import { useStore } from "zustand"

import type { ContextStoreProp } from "@future/context/store"
import type { ActionNavItem } from "@future/header/navItems"
import { domainConfig } from "@future/target/domain"
import { useNavigate } from "@future/router/useNavigate"

const chooseChainTargetInfos = domainConfig.availableTargets
  .filter((targetInfo) => !targetInfo.hideInNetworkList)
  .sort((a, b) => {
    const aFirst = a.name.at(0)
    const bFirst = b.name.at(0)
    const aLower = (aFirst ?? a.name).toLowerCase()
    const bLower = (bFirst ?? b.name).toLowerCase()
    const lowerCaseComparison = aLower.localeCompare(bLower)

    if (lowerCaseComparison !== 0) {
      return lowerCaseComparison
    }

    const isACapitalized = aFirst === aFirst?.toUpperCase()
    const isBCapitalized = bFirst === bFirst?.toUpperCase()

    if (isACapitalized && !isBCapitalized) {
      return -1
    }
    if (!isACapitalized && isBCapitalized) {
      return 1
    }

    return 0
  })

export const useChooseChainNavItems = (props: ContextStoreProp<"initial">) => {
  const navigate = useNavigate()
  const route = useStore(
    props.contextStore,
    (state) => state.route.rootId ?? state.route.fallbackRootId,
  )
  const marketSlug = useStore(
    props.contextStore,
    (state) => state.route.marketSlug ?? state.route.fallbackMarketSlug,
  )

  return chooseChainTargetInfos.map((targetInfo): ActionNavItem => {
    return {
      title: targetInfo.name,
      id: targetInfo.slug,
      type: "action",
      action: {
        type: "handler",
        handler: () => {
          navigate({
            targetSlug: targetInfo.slug,
            route,
            marketSlug,
          })
        },
      },
    }
  })
}
